/**
 * Display helpers for Debate Influence (Spec 1.4). Pure functions — tested.
 */

import { DebateInfluence } from '../types';

/** One-line summary of a cycle's debate influence, e.g. "2 of 6 changed their mind (33%)". */
export const debateInfluenceSummary = (di: DebateInfluence | null | undefined): string | null => {
  if (!di || !di.total_decisions) return null;
  return `${di.decisions_changed} of ${di.total_decisions} changed their mind (${Math.round(di.change_rate_pct)}%)`;
};

/** Per-agent badge text: did this agent change its mind this cycle, or hold? */
export const agentDebateBadge = (di: DebateInfluence | null | undefined, agentId: string): string | null => {
  if (!di || !di.per_agent || !di.per_agent[agentId]) return null;
  const pa = di.per_agent[agentId];
  if (!pa.total) return null;
  return pa.changed > 0 ? `Changed ${pa.changed}/${pa.total}` : 'Held conviction';
};
